<div class="flex flex-col h-full">
  <div>
    <h1>Dokumentafsendelse</h1>
  </div>
  <div class="flex gap-6 flex-1 overflow-hidden">
    <div class="flex flex-col gap-6">
      @if(visKonfiguration()){
      <p-panel header="Konfiguration">
        <div class="control">
          <label>Realtids-dokumentafsendelse i Rådgiverportalen</label>
          <div class="flex gap-2">
            @if(skrivKonfiguration()){
            <p-toggleswitch
              [(ngModel)]="realtidEnabled"
              (onChange)="realtidChanged($event)"
            />
            }
            <span>
              {{ realtidEnabled() ? "Aktiveret" : "Deaktiveret" }}
            </span>
          </div>
        </div>
      </p-panel>
      }
      <p-panel header="Søgning">
        <app-dokument-afsendelse-search />
      </p-panel>
      <p-panel header="Gensend">
        <p-button
          label="Gensend valgte dokumenter"
          icon="pi pi-send"
          (onClick)="gensend()"
          [disabled]="dokAfsendelseService.selectedDokumenter().length === 0"
          [loading]="resendInProgress()"
        ></p-button>
      </p-panel>
    </div>
    <app-dokument-afsendelse-result class="flex-1" />
  </div>
</div>
<p-confirm-dialog />
